module.exports = __webpack_public_path__ + "img/no-card-data.18da60fe.svg";